<template><article><h1>无序滑块</h1>
<p>默认状态下，滑块都是有序的。</p>
<p>通过设置 <code v-pre>order = false</code>，可以使得滑块变得无序。当你需要区分多个滑块的作用时，这将非常有用。</p>
<div class="warning custom-block"><p class="custom-block-title">WARNING</p>
<p>当 <code v-pre>order</code> 的值为 <code v-pre>false</code> 时，参数 &lt;<code v-pre>minRange</code>|<code v-pre>maxRange</code>|<code v-pre>enableCross</code>|<code v-pre>fixed</code>&gt;无效</p>
</div>
<h3 id="一般使用"><a class="header-anchor" href="#一般使用" aria-hidden="true">#</a> 一般使用</h3>
<p><example :value="example1"></example></p>
<h3 id="相互独立的滑块"><a class="header-anchor" href="#相互独立的滑块" aria-hidden="true">#</a> 相互独立的滑块</h3>
<p><example :value="example2"></example></p>
<div class="tip custom-block"><p class="custom-block-title">TIP</p>
<p><code v-pre>v-slot:</code>（字符 <code v-pre>#</code>）仅在 <code v-pre>vue</code> 版本 2.6.0 以上才能使用，否则请使用 <code v-pre>slot</code> 和 <code v-pre>slot-scope</code>。</p>
<p>详情可参阅 <a href="https://vuejs.org/v2/guide/components-slots.html#Named-Slots-Shorthand">官方文档</a></p>
</div>
</article></template>

<script>
  import examples from '@/examples/order.ts'
  export default {
    data () {
      return {
        ...examples
      }
    }
  }
</script>